import React, { useState } from 'react'
import {
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
  CFormSwitch,
  CSmartTable,
} from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilOptions, cilPencil, cilTrash } from '@coreui/icons'
import { toast } from 'react-toastify'

import moment from 'moment'
import ToastComponent from 'src/components/common/TaostComponent.js'
import RoundService from 'src/service/RoundService'
import Notify from '../Notify'
import CommonService from 'src/service/CommonService'

const Table = ({
  users,
  fetchUsers,
  setActivePage,
  setItemsPerPage,
  setColumnSorter,
  itemsPerPage,
  activePage,
  columnSorter,
  loading,
  squadFixtureIds,
  selectedCheckboxes,
  toggleAllCheckboxes,
  toggleCheckbox,
  onEditRound,
}) => {
  const columns = [
    {
      key: 'delete_fixture',
      label: (
        <input
          type="checkbox"
          name="delete_all"
          checked={
            selectedCheckboxes.length === squadFixtureIds.length && squadFixtureIds.length > 0
          }
          onChange={toggleAllCheckboxes}
        />
      ),
      filter: false,
      sorter: false,
    },
    {
      key: 'round',
      _style: { width: '15%' },
      filter: false,
      sorter: false,
    },
    { key: 'start_date', filter: false, sorter: false },
    { label: 'Start Time', key: 'lockout_start_time', filter: false, sorter: false },
    { key: 'end_date', filter: false, sorter: false },
    { label: 'End Time', key: 'lockout_end_time', filter: false, sorter: false },
    { label: 'Restrict Trade', key: 'trade_restriction', filter: false, sorter: true },
    { label: 'Free Trade', key: 'is_free_trades', filter: false, sorter: true },
    {
      key: 'actions',
      label: 'Actions',
      _style: { width: '5%' },
      filter: false,
      sorter: false,
    },
  ]

  // Are you sure want modal
  const [handleYes, setHandleYes] = useState(false)
  const [showConfirm, setShowConfirm] = useState(false)
  const [handleNo, setHandleNo] = useState(false)
  const [tableId, setTableId] = useState(false)

  const handleCancel = () => setShowConfirm(false)

  const handleConfirm = () => {
    deleteRound(tableId)
    return setShowConfirm(false)
  }

  const areYouSureModal = (id) => {
    const data = { id, type: 'round' }
    CommonService.checkItemExists(data).then((res) => {
      if (res.status === 200) {
        if (res.data) {
          ToastComponent(res.message, 'error')
        } else {
          setShowConfirm(true)
          setTableId(id)
        }
      }
    })
  }

  const deleteRound = (id) => {
    RoundService.deleteRound({ id }).then((res) => {
      if (res.status === 200) {
        fetchUsers()
        toast.dismiss()
        ToastComponent(res.message, 'success')
      }
    })
  }

  const updateRestrictAndFreeTradeStatus = (e, id, type) => {
    RoundService.updateRestrictAndFreeTradeStatus({ id, value: e.target.checked, type }).then(
      (res) => {
        if (res.status === 200) {
          fetchUsers()
          toast.dismiss()
          ToastComponent(res.message, 'success')
        }
      },
    )
  }

  // Fixtures created against this round (fixtures.round_id), served with the listing.
  // Reuses the Manage Fixture squad-count pill so both tables read the same.
  const fixtureCountPill = (count) => {
    const total = count ?? 0
    return (
      <span
        className={`ge-squad-count${total > 0 ? '' : ' ge-squad-count--empty'}`}
        title={`${total} ${total === 1 ? 'fixture' : 'fixtures'} in this round`}
      >
        {total}
      </span>
    )
  }

  return (
    <div className="ge-datatable ge-datatable--static">
      <CSmartTable
        columns={columns}
        columnSorter={{
          external: true,
        }}
        sorterValue={columnSorter}
        scopedColumns={{
          delete_fixture: (item) => {
            const fixtureIdExists = squadFixtureIds.some((fixture) => fixture.id === item.id)
            return (
              <td className="py-2">
                {fixtureIdExists && (
                  <input
                    type="checkbox"
                    name="delete"
                    value={item.id}
                    checked={selectedCheckboxes.includes(item.id)}
                    onChange={() => toggleCheckbox(item.id)}
                  />
                )}
              </td>
            )
          },
          round: (item) => (
            <td>
              <span
                className="fw-semibold text-primary"
                role="button"
                onClick={() => onEditRound(item.id)}
              >
                {item.round}
              </span>
              {fixtureCountPill(item.fixtures_count)}
            </td>
          ),
          start_date: (item) => <td>{moment(item.start_date).format('D.MM.YYYY')}</td>,
          end_date: (item) => <td>{moment(item.end_date).format('D.MM.YYYY')}</td>,
          lockout_start_time: (item) => <td>{moment(item.start_date).format('h:mm A')}</td>,
          lockout_end_time: (item) => <td>{moment(item.end_date).format('h:mm A')}</td>,
          trade_restriction: (item) => (
            <td>
              <CFormSwitch
                id={`trade_restriction_${item.id}`}
                label={item?.trade_restriction == 1 ? 'On' : 'Off'}
                checked={item?.trade_restriction}
                onChange={(e) => updateRestrictAndFreeTradeStatus(e, item.id, 'trade_restriction')}
              />
            </td>
          ),
          is_free_trades: (item) => (
            <td>
              <CFormSwitch
                id={`is_free_trades_${item.id}`}
                label={item?.is_free_trades == 1 ? 'On' : 'Off'}
                checked={item?.is_free_trades}
                onChange={(e) => updateRestrictAndFreeTradeStatus(e, item.id, 'is_free_trades')}
              />
            </td>
          ),
          actions: (item) => (
            <td className="py-2">
              <CDropdown alignment="end" portal>
                <CDropdownToggle color="transparent" caret={false} className="p-0">
                  <CIcon icon={cilOptions} role="button" />
                </CDropdownToggle>
                <CDropdownMenu>
                  <CDropdownItem role="button" onClick={() => onEditRound(item.id)}>
                    <CIcon icon={cilPencil} className="me-2" />
                    Edit
                  </CDropdownItem>
                  <CDropdownItem
                    role="button"
                    className="text-danger"
                    onClick={() => areYouSureModal(item.id)}
                  >
                    <CIcon icon={cilTrash} className="me-2" />
                    Delete
                  </CDropdownItem>
                </CDropdownMenu>
              </CDropdown>
            </td>
          ),
        }}
        items={users?.data}
        itemsPerPage={itemsPerPage}
        itemsPerPageSelect
        loading={loading}
        pagination={{
          external: true,
        }}
        paginationProps={{
          activePage: activePage,
          pages: Math.ceil(users?.total / itemsPerPage) || 1,
        }}
        tableProps={{ hover: true, responsive: true, className: 'align-middle mb-0' }}
        onActivePageChange={(activePage) => setActivePage(activePage)}
        onItemsPerPageChange={(itemsPerPage) => {
          setActivePage(1)
          setItemsPerPage(itemsPerPage)
        }}
        onSorterChange={(sorter) => setColumnSorter(sorter)}
      />
      <Notify
        setShowConfirm={setShowConfirm}
        showConfirm={showConfirm}
        setHandleNo={setHandleNo}
        handleNo={handleNo}
        handleYes={handleYes}
        setHandleYes={setHandleYes}
        handleConfirm={handleConfirm}
        handleCancel={handleCancel}
        text="Are you sure you want to delete this?"
      />
    </div>
  )
}

export default Table
